import { render } from "./btcConnect.vue?vue&type=template&id=036c1c4e&scoped=true"
import script from "./btcConnect.vue?vue&type=script&lang=js"
export * from "./btcConnect.vue?vue&type=script&lang=js"

import "./btcConnect.vue?vue&type=style&index=0&id=036c1c4e&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036c1c4e"]])

export default __exports__